"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MARKETING_AB_TESTING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_AB_TESTING;
  }
});
Object.defineProperty(exports, "MARKETING_AD_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_AD_MANAGEMENT;
  }
});
Object.defineProperty(exports, "MARKETING_ATTRIBUTION_REPORTING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_ATTRIBUTION_REPORTING;
  }
});
Object.defineProperty(exports, "MARKETING_BLOG_CONTENT_CREATION", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_BLOG_CONTENT_CREATION;
  }
});
Object.defineProperty(exports, "MARKETING_CMS_MEMBERSHIP", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_CMS_MEMBERSHIP;
  }
});
Object.defineProperty(exports, "MARKETING_CONTACT_ACTIVITY", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_CONTACT_ACTIVITY;
  }
});
Object.defineProperty(exports, "MARKETING_CONTACT_COMPANY_INSIGHTS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_CONTACT_COMPANY_INSIGHTS;
  }
});
Object.defineProperty(exports, "MARKETING_CONTACT_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_CONTACT_MANAGEMENT;
  }
});
Object.defineProperty(exports, "MARKETING_CONTENT_PARTITIONING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_CONTENT_PARTITIONING;
  }
});
Object.defineProperty(exports, "MARKETING_CONVERSATIONAL_BOTS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_CONVERSATIONAL_BOTS;
  }
});
Object.defineProperty(exports, "MARKETING_CONVERSATIONS_INBOX", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_CONVERSATIONS_INBOX;
  }
});
Object.defineProperty(exports, "MARKETING_CTAS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_CTAS;
  }
});
Object.defineProperty(exports, "MARKETING_CUSTOM_EVENT_REPORTING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_CUSTOM_EVENT_REPORTING;
  }
});
Object.defineProperty(exports, "MARKETING_CUSTOM_EVENT_TRIGGERS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_CUSTOM_EVENT_TRIGGERS;
  }
});
Object.defineProperty(exports, "MARKETING_CUSTOM_REPORTING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_CUSTOM_REPORTING;
  }
});
Object.defineProperty(exports, "MARKETING_EMAIL_MARKETING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_EMAIL_MARKETING;
  }
});
Object.defineProperty(exports, "MARKETING_EMAIL_SEND_FREQUENCY_CAP", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_EMAIL_SEND_FREQUENCY_CAP;
  }
});
Object.defineProperty(exports, "MARKETING_FACEBOOK_MESSENGER_TOOLS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_FACEBOOK_MESSENGER_TOOLS;
  }
});
Object.defineProperty(exports, "MARKETING_FORMS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_FORMS;
  }
});
Object.defineProperty(exports, "MARKETING_GOAL_BASED_NURTURING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_GOAL_BASED_NURTURING;
  }
});
Object.defineProperty(exports, "MARKETING_GOOGLE_SEARCH_CONSOLE_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_GOOGLE_SEARCH_CONSOLE_INTEGRATION;
  }
});
Object.defineProperty(exports, "MARKETING_HUBSPOT_BRANDING_REMOVED", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_HUBSPOT_BRANDING_REMOVED;
  }
});
Object.defineProperty(exports, "MARKETING_LANDING_PAGES", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_LANDING_PAGES;
  }
});
Object.defineProperty(exports, "MARKETING_LISTS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_LISTS;
  }
});
Object.defineProperty(exports, "MARKETING_LIVE_CHAT", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_LIVE_CHAT;
  }
});
Object.defineProperty(exports, "MARKETING_MARKETING_AUTOMATION", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_MARKETING_AUTOMATION;
  }
});
Object.defineProperty(exports, "MARKETING_MOBILE_OPTIMIZATION", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_MOBILE_OPTIMIZATION;
  }
});
Object.defineProperty(exports, "MARKETING_PHONE_SUPPORT", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_PHONE_SUPPORT;
  }
});
Object.defineProperty(exports, "MARKETING_POPUP_FORMS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_POPUP_FORMS;
  }
});
Object.defineProperty(exports, "MARKETING_PREDICTIVE_LEAD_SCORING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_PREDICTIVE_LEAD_SCORING;
  }
});
Object.defineProperty(exports, "MARKETING_REPORTING_DASHBOARDS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_REPORTING_DASHBOARDS;
  }
});
Object.defineProperty(exports, "MARKETING_SALESFORCE_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_SALESFORCE_INTEGRATION;
  }
});
Object.defineProperty(exports, "MARKETING_SEO_CONTENT_STRATEGY", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_SEO_CONTENT_STRATEGY;
  }
});
Object.defineProperty(exports, "MARKETING_SMART_CONTENT", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_SMART_CONTENT;
  }
});
Object.defineProperty(exports, "MARKETING_SOCIAL", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_SOCIAL;
  }
});
Object.defineProperty(exports, "MARKETING_SSL", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_SSL;
  }
});
Object.defineProperty(exports, "MARKETING_SSO", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_SSO;
  }
});
Object.defineProperty(exports, "MARKETING_SUBDOMAIN_AVAILABILITY", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_SUBDOMAIN_AVAILABILITY;
  }
});
Object.defineProperty(exports, "MARKETING_TEAM_EMAIL", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_TEAM_EMAIL;
  }
});
Object.defineProperty(exports, "MARKETING_TEAMS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_TEAMS;
  }
});
Object.defineProperty(exports, "MARKETING_VIDEO", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_VIDEO;
  }
});
Object.defineProperty(exports, "MARKETING_YOUTUBE_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.MARKETING_YOUTUBE_INTEGRATION;
  }
});

var _HubSpotFeature = require("../HubSpotFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/hubspotFeatures/Marketing.js
// module id = 722
// module chunks = 209 210 211 212